// import $ from 'jquery'
import 'slick-carousel'
$ =  require('jquery').noConflict();
window.$ = window.jQuery = $

